import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=0bd67199&scoped=true&"
import script from "./helpCenter.vue?vue&type=script&lang=js&"
export * from "./helpCenter.vue?vue&type=script&lang=js&"
import style0 from "./helpCenter.vue?vue&type=style&index=0&id=0bd67199&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd67199",
  null
  
)

export default component.exports